import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ContentBoxStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    width: 75%;

    @media screen and (max-width: 850px) {
        margin-bottom: 15px;
        width: 100%;
        order: 1;
    }
`;

const Title = styled.div`
    font-weight: bold;
    font-size: 18px;

    @media screen and (max-width: 570px) {
        font-size: 18px;
        max-width: 62%;
    }
`;

const Text = styled.p`
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
    margin: 10px 0;
`;

const Collapsable = styled.div`
    flex-basis: 100%;
    overflow: hidden;
    transition: all 400ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    height: ${props => props.visible ? `${props.initialHeight}px`: 0};
`;

const ShowMore = styled.button`
    border: none;
    border-bottom: 1px solid #212121;
    color: ${props => props.theme.content.color};
    border-color: ${props => props.theme.content.color};
    background-color: transparent;
    font-size: 13px;

    cursor: pointer;

    margin-left: auto;
`;


const ContentBox = (props) => {
    const { name,  description } = props;
    const [visible, setVisibile] = useState(false);
    const [initialHeight, setInitialHeight] = useState(0);
    let collapsable = null;

    const toggle = () => {
        visible ? setVisibile(false) : setVisibile(true);
    };

    useEffect(() => {
        setInitialHeight(collapsable.clientHeight + 20);
    },[]);

    return (
        <ContentBoxStyled>

            <Title>{name}</Title>
            <ShowMore onClick={toggle} >{visible ? 'Скрий' : 'Прочети повече'}</ShowMore>

            <Collapsable initialHeight={initialHeight} visible={visible}>
                <Text ref={(el) => collapsable = el}>{description}</Text>
            </Collapsable>

        </ContentBoxStyled>
    );
}

export default ContentBox;